import {
  UI2FileUploadField,
  IUI2FileUploadFieldProps,
} from '../ui2-file-upload-field/ui2-file-upload-field'

// Document capture on DW is a file-upload preset: accepts images + PDFs
// (already the base default), with document-friendly empty-state copy.
// Camera-specific props from the shared contract (captureHelpText,
// enablePageDetection, etc.) are present but unused on desktop — no camera.
export interface IUI2DocumentCaptureFieldProps extends IUI2FileUploadFieldProps {}

export class UI2DocumentCaptureField extends UI2FileUploadField {
  public static defaultProps: Partial<IUI2DocumentCaptureFieldProps> = {
    ...UI2FileUploadField.defaultProps,
    placeholder: 'Scan or upload document pages',
    addMoreMessage: 'Add Page',
  }
}
